import { unstable_cache } from 'next/cache';

import { getChannel, getIndexName, getPlaceId, typesense } from '@lib/server';
import { TypesenseEventDocument } from '@types';
import { addMonths } from 'date-fns';

export async function getVenueEventsParamData({ domain, venue }: { domain: string; venue: string }) {
  const channel = await getChannel(domain);

  if (!channel?.channelId) return {};

  const { placeId } = (await getPlaceId(channel, venue)) || {};

  const now = Math.floor(Date.now() / 1000);
  const nowPlus1Year = Math.floor(addMonths(new Date(), 12).getTime() / 1000);

  try {
    const events: TypesenseEventDocument[] =
      (await unstable_cache(
        () =>
          typesense
            .collections<TypesenseEventDocument>(getIndexName('event'))
            .documents()
            .search({
              q: '',
              query_by: '*',
              sort_by: 'dates:asc',
              group_by: 'slug', // Group results by the slug field
              group_limit: 1, // Only get 1 document per group (per unique slug)
              filter_by: `_referencedBy:=[${placeId}] && dates:>=${now} && dates:<=${nowPlus1Year}`,
              limit: 250,
            })
            .then((res) => res.grouped_hits?.flatMap((hit) => hit.hits?.map((h) => h.document))),
        ['venue-events', placeId || ''],
        { revalidate: false, tags: [channel?.channelId] },
      )()) || [];

    return {
      events,
    };
  } catch (error) {
    console.error(error);
    return {};
  }
}
